import React, { Component, useState, Fragment, useEffect, useRef, useMemo } from 'react';
import { withStyles } from "@material-ui/core/styles";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import HomeIcon from '@mui/icons-material/Home';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import GrainIcon from '@mui/icons-material/Grain';
import LightModeIcon from '@mui/icons-material/LightMode';
import Checkbox from '@mui/material/Checkbox';
import ClearIcon from '@material-ui/icons/Clear';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import { AppBar, Toolbar, Typography, Button, IconButton, Modal, Grid, Box, TextField, FormControl, Drawer, Menu, Paper, Select, MenuItem, TableFooter, TableRow, TableCell } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import Card from '@material-ui/core/Card';
import SearchIcon from '@material-ui/icons/Search';
import { createTheme, MuiThemeProvider } from "@material-ui/core/styles";
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import EditIcon from '@mui/icons-material/Edit';
import { PostAddOutlined } from '@mui/icons-material';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@material-ui/icons/Visibility';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { customTheme, getColorfont, getColor } from '../../../StyleComponents/Styledatatable';
import classNames from 'classnames';
import ApprovalIcon from '@mui/icons-material/Approval';
import FilterListIcon from '@mui/icons-material/FilterAlt';
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import useStyles from '../../../StyleComponents/StyleFunctionComponent';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Skeleton from '@material-ui/lab/Skeleton';
import LinearProgress from '@mui/material/LinearProgress';
import TransformOutlinedIcon from '@material-ui/icons/TransformOutlined';
import { API_BASE_URL, token, userLevel, adminId } from '../../../../constants';

const JohnDeereApiTransferReport = () => {
    const { id } = useParams();

    const history = useHistory();
    const [openSidebar, setOpenSidebar] = useState(false);
    const [filterText, setFilterText] = useState("");
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const [perPage, setPerPage] = useState(50);
    const [page, setPage] = useState(0);
    const [search, setSearch] = useState('');
    const [totalCount, setTotalCount] = useState(0);
    const currentDate = new Date();
    const sevenDaysAgo = new Date(currentDate);
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 5);
    const [fromDate, setFromDate] = useState(sevenDaysAgo.toISOString().split('T')[0]);
    const [toDate, setToDate] = useState(currentDate.toISOString().split('T')[0]);
    const [enquirySource, setEnquirySource] = useState([]);
    const [selectedState, setSelectedState] = useState();
    const [stateOptions, setStateOptions] = useState([]);
    const [selectedBrand, setSelectedBrand] = useState();
    const [brandOptions, setBrandOptions] = useState([]);
    const [selectedExecutiveId, setSelectedExecutiveId] = useState(null);
    const [executiveOptions, setExecutiveOptions] = useState([]);
    const [sources, setSources] = useState([]);
    const [selectedSource, setSelectedSource] = useState();
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [openTransferModal, setOpenTransferModal] = useState(false);
    const [selectedTransferId, setSelectedTransferId] = useState(null);
    const [transferLoading, setTransferLoading] = useState(false);
    const handleMoveToTransfer = (id) => {
        setSelectedTransferId(id);
        setOpenTransferModal(true);
    };

    const submitMoveToTransfer = async () => {
        try {
            setTransferLoading(true);

            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
            };

            const payload = {
                id: selectedTransferId,
            };

            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/move-to-available-api`,
                payload,
                config
            );

            setSnackbarMessage(
                response?.data?.message || "Moved successfully."
            );
            setSnackbarOpen(true);

            setOpenTransferModal(false);
            setSelectedTransferId(null);

            fetchData(); // Refresh table

        } catch (error) {
            console.error(error);

            setSnackbarMessage(
                error?.response?.data?.message || "Failed to move record."
            );
            setSnackbarOpen(true);
        } finally {
            setTransferLoading(false);
        }
    };
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${API_BASE_URL}/webApi/sources`);
                const data = response.data.data;
                setSources(data.map(item => item.enquiry_from));
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);

    const handleSelectChange = (event) => {
        setSelectedSource(event.target.value);
    };

    useEffect(() => {
        const fetchDatabrand = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };

                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/brand-list`, config);

                const statelist = response.data.data.map(item => ({
                    id: item.brand_id,
                    title: item.brand_name,
                }));

                setBrandOptions(statelist);

            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };
        fetchDatabrand();
    }, []);

    useEffect(() => {
        const fetchDatastate = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,

                };

                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/state-list`, config);
                const statelist = response.data.data.map(item => ({
                    id: item.state_id,
                    title: item.state_name,
                }));

                setStateOptions(statelist);

            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };

        fetchDatastate();
    }, []);


    useEffect(() => {
        const fetchDatalist = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,

                };

                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/executive-list`, config);
                const mappedData = response.data.data.map(item => ({
                    id: item.admin_id,
                    title: item.username,
                }));

                setExecutiveOptions(mappedData);
            } catch (error) {
                console.error('Error fetching executives:', error);
            }
        };

        fetchDatalist();
    }, []);

    const handleExecutiveChange = (event) => {
        const selectedId = event.target.value;
        setSelectedExecutiveId(selectedId);
    };
    const handleStateChange = (event, newValue) => {
        setSelectedState(newValue);
    };

    const handleBrandChange = (event, newValue) => {
        setSelectedBrand(newValue);
    };


    const fetchData = async () => {
        setIsLoading(true);
        setError(null);

        try {
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
            };

            const requestData = {
                page: page + 1,
                pagination: perPage,
                start_date: fromDate,
                end_date: toDate,
                search: search,
            };

            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/client-api-log-report`,
                requestData,
                config
            );

            const apiData = response.data.data;

            const mappedData = apiData.data.map((item, index) => ({
                sn: ((page * perPage) + index + 1),
                id: item.id,
                log_date: item.log_date,
                log_time: item.log_time,
                enquiry_count: item.enquiry_count,
                status_name: item.status?.name || "",
                retransfer_log_id: item.retransfer_log_id || "",
                created_at: new Date(item.created_at).toLocaleString("en-IN"),
            }));

            setData(mappedData);
            setTotalCount(apiData.total);

        } catch (error) {
            console.error(error);
            setError("Failed to fetch report");
        } finally {
            setIsLoading(false);
        }
    };
    const source = axios.CancelToken.source();
    const sourceRef = useRef(null);

    useEffect(() => {
        fetchData();
    }, [page, perPage]);

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        if (name === 'fromDate') {
            setFromDate(value);
        } else if (name === 'toDate') {
            setToDate(value);
        }
    };

    const handlePerPageChange = (e) => {
        setPerPage(Number(e.target.value));
    };

    const handlePrevious = () => {
        if (page > 0) {
            setPage(page - 1);
        }
    };

    const handleNext = () => {
        setPage(page + 1);
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setPage(0);
        fetchData();
        setOpenSidebar(false);
    };
    const clearForm = () => {
        setSelectedBrand(null);
        setSelectedState(null);
        setSelectedSource("");
        setSearch("");
        setPage(0);
        fetchData();
    };

    const handleView = (id) => {
        window.open(
            `/app/JohnDeereApiTransferViewReport/${id}`,
            "_blank"
        );
    };

    const columns = [
        {
            name: "sn",
            label: "Sn",
            options: {

                setCellProps: () => ({
                    align: "center",
                }),
            },
        },
        {
            name: "log_date",
            label: "Log Date",
        },
        {
            name: "log_time",
            label: "Log Time",
        },
        {
            name: "enquiry_count",
            label: "Enquiry Count",
            options: {

                setCellProps: () => ({
                    align: "center",
                }),
            },
        },
        {
            name: "status_name",
            label: "Status",
            options: {
                customBodyRender: (value) => (
                    <Button
                        size="small"
                        style={{
                            backgroundColor:
                                value === "Re Transfer"
                                    ? "rgb(240, 129, 150)"
                                    : "rgb(179, 230, 196)",
                            color:
                                value === "Re Transfer"
                                    ? "rgb(48, 33, 36)"
                                    : "rgb(45, 61, 50)",

                            minWidth: "120px",
                        }}
                    >
                        {value}
                    </Button>
                ),
            },
        },
        {
            name: "retransfer_log_id",
            label: "Re Transfer Log ID",
            options: {

                setCellProps: () => ({
                    align: "center",
                }),
            },
        },
        {
            name: "created_at",
            label: "Created At",
        },

        {
            name: "id",
            label: "Move To Transfer",
            options: {
                filter: false,
                sort: false,
                empty: true,
                setCellProps: () => ({
                    align: "center",
                }),

                customBodyRender: (value) => {
                    return (
                        <IconButton
                            size="small"
                            onClick={() => handleMoveToTransfer(value)}
                            style={{
                                color: "#ff9800",
                                background: "#fff3e0",
                                marginRight: "5px",
                            }}
                            title="Move To Transfer"
                        >
                            <TransformOutlinedIcon />
                        </IconButton>
                    );
                },
            },
        },
        {
            name: "id",
            label: "Action",
            options: {
                filter: false,
                sort: false,
                empty: true,
                setCellProps: () => ({
                    align: "center",
                }),

                customBodyRender: (value) => {
                    return (
                        <IconButton
                            size="small"
                            onClick={() => handleView(value)}
                            style={{
                                color: "#1976d2",
                                background: "#e3f2fd",
                            }}
                        >
                            <VisibilityIcon />
                        </IconButton>
                    );
                },
            },
        },
    ];

    const CustomToolbarAction = ({ toggleFilter }) => (
        <IconButton aria-label="Filter list" onClick={toggleFilter}>
            <FilterListIcon onClick={toggleSidebar} />
        </IconButton>
    );


    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.shiftKey && event.key === 'F') {
                setOpenSidebar(true);
            }
        };
        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, []);

    const toggleSidebar = () => {
        setOpenSidebar(!openSidebar);
    };
    const options = {
        rowsPerPage: perPage,
        selectableRows: 'none',
        page: page,
        serverSide: true,
        count: totalCount,
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setPage(tableState.page);
                    break;
                case 'changeRowsPerPage':
                    setPerPage(tableState.rowsPerPage);
                    setPage(0);
                    break;
                default:
                    break;
            }
        },

        customToolbar: () => <CustomToolbarAction />,
        filter: false,
        filterType: "dropdown",
        responsive: "standard",
        fixedHeader: true,
        fixedSelectColumn: true,
        overflowy: "auto",
        overflowx: "auto",
        rowsPerPageOptions: [10, 50, 100, 500, 1000, 10000, { value: totalCount, label: 'All' }],
        customFilterDialogFooter: (currentFilter, applyNewFilter) => (
            <div>
                <TextField
                    label="Filter Data"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                    fullWidth
                />
                <Button onClick={applyNewFilter} variant="contained" color="primary">
                    Apply Filter
                </Button>
                <Button onClick={() => setOpenSidebar(false)} variant="contained" color="secondary">
                    Cancel
                </Button>
            </div>
        ),

    };
    const currentTheme = customTheme(true);
    const classes = useStyles();
    const memoizedData = useMemo(() => data, [data]);
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    return (
        <>
            <div>
                <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                    <MuiAlert onClose={handleCloseSnackbar} severity="info" sx={{ width: '100%' }}>
                        {snackbarMessage}
                    </MuiAlert>
                </Snackbar>
            </div>
            <Box sx={{ width: '100%' }}>
                <Typography className={classNames(classes.pagetittle, classes.pagetittlestyle)}>
                    John Deere API Transfer Log Report
                </Typography>
                <hr className={classes.horizontalline} />
            </Box>

            <MuiThemeProvider theme={currentTheme}>
                {
                    isLoading ? (
                        <LinearProgress />

                    ) : (
                        ""
                    )
                }

                <MUIDataTable
                    title={
                        isLoading ? (
                            <Skeleton animation="wave" />

                        ) : (
                            <Typography className={classes.tabletittle} >

                            </Typography>
                        )
                    }
                    data={memoizedData}
                    columns={columns}
                    options={options}
                />

            </MuiThemeProvider>


            <Drawer anchor="right" open={openSidebar}
                PaperProps={{
                    style: {
                        width: "100%",
                        maxWidth: 300,
                        padding: "10px"
                    }
                }}
                onClose={() => setOpenSidebar(false)}
            >
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={1}>
                        <Grid item xs={4} sm={2} lg={12} style={{ textAlign: "right", cursor: "pointer", }}>
                            <ClearIcon style={{ color: '#c0392b' }} onClick={() => setOpenSidebar(false)} />
                        </Grid>
                        <Grid item xs={4} sm={2} lg={12} >
                            <br />
                            <Typography className={classes.tabletittle} >
                                Filter
                            </Typography>
                        </Grid>
                    </Grid>
                    <div className={classes.root} style={{ paddingRight: "22px", paddingLeft: "22px" }}>
                        <div className={classes.root}>
                            <Grid container spacing={1}>


                                <Grid item xs={4} sm={2} lg={12} >
                                    <input className={classes.inputform} type="date" name="fromDate" value={fromDate} onChange={handleDateChange} />

                                </Grid>

                                <Grid item xs={4} sm={2} lg={12}>
                                    <input className={classes.inputform} type="date" name="toDate" value={toDate} onChange={handleDateChange} />
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                    <br />
                    <Grid >
                        <Grid item xs={4} sm={2} lg={12} style={{ margin: "auto", padding: "auto", textAlign: "center" }}>
                            <Button
                                type='submit'
                                style={{ marginRight: "10px" }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ApprovalIcon />}>
                                Apply
                            </Button>
                            <Button
                                type="button" onClick={clearForm}
                                style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ClearIcon />}>
                                Clear
                            </Button>
                        </Grid>
                    </Grid>
                    <br />
                </form>
            </Drawer >

            {/* <Modal
                open={openTransferModal}
                onClose={() => setOpenTransferModal(false)}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        bgcolor: "#fff",
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 3,
                        width: 500,
                    }}
                >
                    <Typography
                        variant="h6"
                        style={{
                            marginBottom: "15px",
                            fontWeight: 600,
                        }}
                    >
                        Move To Transfer
                    </Typography>

                    <Typography style={{ marginBottom: "20px" }}>
                        Are you sure you want to move this record to transfer?
                    </Typography>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: "10px",
                        }}
                    >
                        <Button
                            variant="outlined"
                            onClick={() => setOpenTransferModal(false)}
                        >
                            Cancel
                        </Button>

                        <Button
                            variant="contained"
                            color="primary"
                            disabled={transferLoading}
                            onClick={submitMoveToTransfer}
                        >
                            {transferLoading ? "Processing..." : "Confirm"}
                        </Button>
                    </div>
                </Box>
            </Modal> */}

            <Modal
                open={openTransferModal}
                onClose={() => setOpenTransferModal(false)}
            >
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: 500,
                        bgcolor: "#ffffff",
                        borderRadius: "20px",
                        boxShadow: "0px 20px 60px rgba(0,0,0,0.15)",
                        overflow: "hidden",
                        outline: "none",
                    }}
                >
                    {/* Header */}
                    <Box
                        sx={{
                            background:
                                "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                            p: 3,
                            textAlign: "center",
                        }}
                    >
                        <TransformOutlinedIcon
                            style={{
                                fontSize: 55,
                                color: "#fff",
                                background: "rgba(255,255,255,0.15)",
                                padding: 10,
                                borderRadius: "50%",
                            }}
                        />

                        <Typography
                            variant="h5"
                            style={{
                                color: "#fff",
                                fontWeight: 700,
                                marginTop: 10,
                            }}
                        >
                            Move To Transfer
                        </Typography>
                    </Box>

                    {/* Content */}
                    <Box sx={{ p: 4, textAlign: "center" }}>
                        <Typography
                            variant="h6"
                            style={{
                                fontWeight: 600,
                                color: "#2c3e50",
                                marginBottom: 10,
                            }}
                        >
                            Confirm Transfer
                        </Typography>

                        <Typography
                            style={{
                                color: "#6c757d",
                                lineHeight: 1.8,
                                fontSize: "15px",
                                marginBottom: 30,
                            }}
                        >
                            Are you sure you want to move this record to the
                            transfer queue?
                            <br />
                            This action will make the record available for
                            transfer processing.
                        </Typography>

                        {/* Buttons */}
                        <Box
                            sx={{
                                display: "flex",
                                justifyContent: "center",
                                gap: 2,
                            }}
                        >
                            <Button
                                variant="outlined"
                                onClick={() => setOpenTransferModal(false)}
                                style={{
                                    borderRadius: "12px",
                                    minWidth: "120px",
                                    padding: "10px 25px",
                                    fontWeight: 600,
                                    textTransform: "none",
                                    borderColor: "#ced4da",
                                }}
                            >
                                Cancel
                            </Button>

                            <Button
                                variant="contained"
                                disabled={transferLoading}
                                onClick={submitMoveToTransfer}
                                style={{
                                    borderRadius: "12px",
                                    minWidth: "180px",
                                    padding: "10px 25px",
                                    fontWeight: 700,
                                    textTransform: "none",
                                    background:
                                        "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                                    boxShadow:
                                        "0 8px 20px rgba(40,167,69,0.35)",
                                }}
                            >
                                {transferLoading
                                    ? "Processing..."
                                    : "✓ Confirm Transfer"}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

        </>
    );
};

export default JohnDeereApiTransferReport;